<template>
  <div class="detail">
    <div class="container">
      <h3 class="detail-title">
        <span v-if="tfType === 'TF Target'">TF Target Details</span>
        <span v-else>TF Details</span>
        <span class="detail-update-time">
          Last update:
          {{
            detail.updateTime
              ? dayjs(detail.updateTime).format("YYYY-MM-DD")
              : "-"
          }}
        </span>
      </h3>
      <div class="detail-main">
        <h3 class="detail-title">Basic information</h3>
        <div class="detail-desc">
          <div
            v-for="item in baseInfo"
            :key="item.label"
            class="detail-desc__item"
          >
            <b class="detail-desc__label"> {{ `${item.label}:` }} </b>
            <div v-if="!item.isLink" class="detail-desc__value">
              {{ item.value }}
            </div>
            <a v-else :href="item.value" target="_blank">{{ item.value }}</a>
          </div>
        </div>
        <h3 class="detail-title">Transcript</h3>
        <div class="detail-desc">
          <div
            v-for="item in transcript"
            :key="item.label"
            class="detail-desc__item"
          >
            <b class="detail-desc__label"> {{ `${item.label}:` }} </b>
            <div v-if="!item.isLink" class="detail-desc__value">
              {{ item.value }}
            </div>
            <a v-else :href="item.value" target="_blank">{{ item.value }}</a>
          </div>
        </div>
        <h3 class="detail-title">Post-Translational Modification</h3>
        <div class="detail-desc">
          <div
            v-for="item in modification"
            :key="item.label"
            class="detail-desc__item"
          >
            <b class="detail-desc__label"> {{ `${item.label}:` }} </b>
            <div v-if="!item.isLink" class="detail-desc__value">
              {{ item.value }}
            </div>
            <a v-else :href="item.value" target="_blank">{{ item.value }}</a>
          </div>
        </div>
        <h3 class="detail-title" v-if="tfType === 'TF Target'">Relative TF</h3>
        <h3 class="detail-title" v-else>Relative TF Target</h3>
        <div class="detail-desc" style="grid-template-columns: 1fr; padding: 0">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column label="Ensembl ID" prop="ensemblId" width="180">
            </el-table-column>
            <el-table-column label="Gene ID" prop="geneId"></el-table-column>
            <el-table-column label="Family" prop="tfFamilies">
            </el-table-column>
            <el-table-column label="Species" min-width="140" prop="species">
            </el-table-column>
            <el-table-column align="center" label="Details">
              <template v-slot="{ row }">
                <el-button type="text" @click="handleView(row)">
                  View
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="pageInfo.page"
            :page-size="pageInfo.pageSize"
            :total="pageInfo.total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
            style="margin-top: 10px"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  retrieveDataBasedOnID,
  targetRetrieveDataBasedOnID,
} from "@/api/detail";
import dayjs from "dayjs";
import { listRelativeTfTarget, listRelativeTf } from "@/api/search";

export default {
  name: "DetailView",
  computed: {
    dayjs() {
      return dayjs;
    },
  },
  mounted() {
    this.initData();
    this.getTableData();
  },
  data() {
    return {
      detail: {
        updateTime: null,
      },
      baseInfo: [
        {
          label: "TF",
          value: "",
          isLink: false,
        },
        {
          label: "Full Name",
          value: "",
          isLink: false,
        },
        {
          label: "Species",
          value: "",
          isLink: false,
        },
        {
          label: "Gene Type",
          value: "",
          isLink: false,
        },
        {
          label: "TF Categories",
          value: "",
          isLink: false,
        },
        // {
        //   label: "Gene Symbol",
        //   value: "",
        //   isLink: false,
        // },
        {
          label: "TF Families",
          value: "",
          isLink: false,
        },
        {
          label: "Position",
          value: "",
          isLink: false,
        },
        {
          label: "Ensembl ID",
          value: "",
          isLink: false,
        },
        {
          label: "Uniprot Swissprot",
          value: "",
          isLink: false,
        },
        {
          label: "Ensembl ID Link",
          value: "",
          isLink: true,
        },
        {
          label: "Uniprot Swissprot Link",
          value: "",
          isLink: true,
        },
        {
          label: "Gene ID",
          value: "",
          isLink: false,
        },
        {
          label: "Gene ID Link",
          value: "",
          isLink: true,
        },
      ],
      transcript: [
        {
          label: "Name",
          value: "",
          isLink: false,
        },
        {
          label: "Transcript ID",
          value: "",
          isLink: false,
        },
        {
          label: "Transcripts Length",
          value: "",
          isLink: false,
        },
        {
          label: "Protein ID",
          value: "",
          isLink: false,
        },
        {
          label: "Protein Length",
          value: "",
          isLink: false,
        },
        {
          label: "UniProtKB ID",
          value: "",
          isLink: false,
        },
      ],
      modification: [
        {
          label: "Ensembl ID",
          value: "",
          isLink: false,
        },
        {
          label: "Uniprot ID",
          value: "",
          isLink: false,
        },
        {
          label: "Uniprot ID Link",
          value: "",
          isLink: true,
        },
        {
          label: "Type",
          value: "",
          isLink: false,
        },
        {
          label: "Position",
          value: "",
          isLink: false,
        },
        {
          label: "Source ID",
          value: "",
          isLink: false,
        },
        {
          label: "Source ID Link",
          value: "",
          isLink: true,
        },
        {
          label: "Source",
          value: "",
          isLink: false,
        },
        {
          label: "Source Link",
          value: "",
          isLink: true,
        },
      ],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      tfType: this.$route.query.tfType === "TF Target" ? "TF Target" : "TF",
    };
  },
  methods: {
    initData() {
      const id = this.$route.query.id || "";
      const currentApi =
        this.tfType === "TF Target"
          ? targetRetrieveDataBasedOnID
          : retrieveDataBasedOnID;
      currentApi(id).then((res) => {
        const store = res.data;
        this.detail = store;
        this.baseInfo = [
          {
            label: "TF",
            value: store.tfName,
            isLink: false,
          },
          {
            label: "Full Name",
            value: store.fullName,
            isLink: false,
          },
          {
            label: "Species",
            value: store.species,
            isLink: false,
          },
          {
            label: "Gene Type",
            value: store.geneType,
            isLink: false,
          },
          {
            label: "TF Categories",
            value: store.tfCategories,
            isLink: false,
          },
          // {
          //   label: "Gene Symbol",
          //   value: store.geneSymbol,
          //   isLink: false,
          // },
          {
            label: "TF Families",
            value: store.tfFamilies,
            isLink: false,
          },
          {
            label: "Position",
            value: store.basicInformationPosition,
            isLink: false,
          },
          {
            label: "Ensembl ID",
            value: store.ensemblId,
            isLink: false,
          },
          {
            label: "Uniprot Swissprot",
            value: store.uniprotSwissprot,
            isLink: false,
          },
          {
            label: "Ensembl ID Link",
            value: store.ensemblIdLink,
            isLink: true,
          },
          {
            label: "Uniprot Swissprot Link",
            value: store.uniprotSwissprotLink,
            isLink: true,
          },
          {
            label: "Gene ID",
            value: store.geneId,
            isLink: false,
          },
          {
            label: "Gene ID Link",
            value: store.geneIdLink,
            isLink: true,
          },
        ];
        this.transcript = [
          {
            label: "Name",
            value: store.transcriptName,
            isLink: false,
          },
          {
            label: "Transcript ID",
            value: store.transcriptId,
            isLink: false,
          },
          {
            label: "Transcripts Length",
            value: store.transcriptLength,
            isLink: false,
          },
          {
            label: "Protein ID",
            value: store.proteinId,
            isLink: false,
          },
          {
            label: "Protein Length",
            value: store.proteinLength,
            isLink: false,
          },
          {
            label: "UniProtKB ID",
            value: store.uniprotKbId,
            isLink: false,
          },
        ];
        this.modification = [
          {
            label: "Ensembl ID",
            value: store.ensemblId,
            isLink: false,
          },
          {
            label: "Uniprot ID",
            value: store.uniprotId,
            isLink: false,
          },
          {
            label: "Uniprot ID Link",
            value: store.uniprotIdLink,
            isLink: true,
          },
          {
            label: "Type",
            value: store.type,
            isLink: false,
          },
          {
            label: "Position",
            value: store.postTranslationalModificationPosition,
            isLink: false,
          },
          {
            label: "Source ID",
            value: store.sourceId,
            isLink: false,
          },
          {
            label: "Source ID Link",
            value: store.sourceIdLink,
            isLink: true,
          },
          {
            label: "Source",
            value: store.source,
            isLink: false,
          },
          {
            label: "Source Link",
            value: store.sourceLink,
            isLink: true,
          },
        ];
      });
    },
    getTableData() {
      this.tableLoading = true;
      const currentApi =
        this.tfType === "TF Target" ? listRelativeTf : listRelativeTfTarget;
      // 构造请求参数
      let params = {
        page: this.pageInfo.page,
        limit: this.pageInfo.pageSize,
      };
      if (this.tfType === "TF Target") {
        params.targetId = this.$route.query.id;
      } else {
        params.tfId = this.$route.query.id;
      }
      // 执行请求
      currentApi(params)
        .then((res) => {
          this.tableData = res.data;
          this.pageInfo.total = res.count;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleCurrentChange() {
      this.getTableData();
    },
    handleView(row) {
      const { href } = this.$router.resolve({
        path: "/detail",
        query: {
          id: row.id,
          tfType: this.tfType === "TF Target" ? "TF" : "TF Target",
        },
      });
      window.open(href);
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding: px2rem(20) 0;

  .detail-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: px2rem(20);
    font-weight: bold;
    color: #fff;
    background-color: $--color-primary;
    padding: px2rem(20);
    border-radius: px2rem(6);
    margin-bottom: px2rem(20);
  }

  .detail-update-time {
    font-size: px2rem(16);
  }

  .detail-main {
    padding: px2rem(20);

    .detail-title {
      background-color: $--color-secondary;
    }

    .detail-desc {
      padding: 0 20px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      font-size: px2rem(16);
      line-height: 2.5;
      margin-bottom: px2rem(30);
    }

    .detail-desc__item {
      display: flex;

      a {
        color: $--color-primary;
        &:hover {
          text-decoration: underline;
        }

        &:visited {
          color: $--color-primary-light-6;
        }
      }
    }

    .detail-desc__label {
      margin-right: px2rem(6);
    }

    .detail-desc__value {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

::v-deep .el-table th.el-table__cell {
  background-color: #f5f8ff;
  line-height: 1;
}

::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 0;
}

::v-deep .el-pagination {
  display: flex;
  align-items: center;
}
</style>
